import { t } from "i18next";
import toast from "react-hot-toast";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import { api } from "../../../../../../services/api/api";
import { showApiErrorToast } from "../../../../../../services/api/error";
import OdooFieldMappingForm from "./OdooFieldMappingForm";

interface OdooFieldMappingAdminActionsProps {
  mapping: EasyTech.Odoo.FieldMapping;
  onChange: () => void;
}

export default function OdooFieldMappingAdminActions({
  mapping,
  onChange
}: OdooFieldMappingAdminActionsProps) {
  const updateMapping = (updated: EasyTech.Odoo.FieldMapping): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (!updated.odooField || updated.odooField.trim().length === 0) {
        toast.error(t("common:formError", "Formulaire invalide"));
        return reject();
      }

      const payload: EasyTech.Odoo.FieldMappingUpdateRequest = {
        odooField: updated.odooField.trim(),
        description: updated.description ? updated.description.trim() : undefined
      };

      api.put(`admin/odoo/mappings/${mapping.id}`, payload)
        .then(() => {
          onChange();
          toast.success(t("admin:odoo.updateSuccess", "Mapping Odoo mis à jour"));
          return resolve();
        })
        .catch((error: any) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: t("admin:odoo.updateError", "Erreur lors de la mise à jour") });
          return reject();
        });
    });
  };

  return (
    <div className="admin-wo-actions flex items-center justify-end">
      <EditCreateDrawer
        data={mapping}
        entityName={t("admin:odoo.entityName", "Mapping Odoo")}
        drawerTitle={t("admin:odoo.editDrawerTitle", "Modifier la correspondance Odoo")}
        FormComponent={OdooFieldMappingForm}
        isNotCreatable={true}
        onSubmit={updateMapping}
      />
    </div>
  );
}
